import { useArrayField, useFormApi, useFormState } from "informedv4";
import * as React from "react";
import Collapsible from "react-collapsible";
import { FormApiFullDefinition, StudyCustomisationModal, StudyCustomisationModalFormValues } from "../StudyCustomisationModal";

export interface CustomisationFieldProps {
    arrayFieldName: string;
    field: string;
    index: number;
    initialValue: any;
    formats: { id: string; name: string }[];
    importances: { id: string; name: string }[];
}

export interface StudyCustomisationFormValues {
    siteItems: StudyCustomisationModalFormValues[];
    subjectItems: StudyCustomisationModalFormValues[];
}

export const CustomisationTab = ({ arrayFieldName, formats, importances }) => {
    const { arrayFieldState, arrayFieldApi } = useArrayField({ name: arrayFieldName } as any);

    return (
        <>
            {arrayFieldState.fields.map(({ arrayFieldItemState }, index) => {
                return (
                    <CustomisationField arrayFieldName={arrayFieldItemState.name} key={arrayFieldItemState.key} index={index} initialValue={arrayFieldItemState.initialValue} field={arrayFieldItemState.name} formats={formats} importances={importances} />
                );
            })}
        </>
    );
}

export const CustomisationField = ({ arrayFieldName, initialValue, index, field, formats, importances }: CustomisationFieldProps) => {
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const formApi = useFormApi();

    const summaryTagGenerator = () => {

        const itemValues = formApi.getValue(`${arrayFieldName}`) as any;
        if (!itemValues) return "";


        let summaryTag = "";
        if (initialValue.isDisplayTextAvailable) summaryTag += `Display Text of '${itemValues.displayText}'.`;
        if (initialValue.isFormatAvailable) summaryTag += ` Format '${itemValues.format?.name}'.`;
        if (initialValue.isMinAndMaxLengthAvailable) summaryTag += ` Length Range '${itemValues.minimumLength}' - '${itemValues.maximumLength}'.`;
        if (initialValue.isMinAndMaxValueAvailable) summaryTag += ` Value Range '${itemValues.minimumValue}' - '${itemValues.maximumValue}'.`;
        if (initialValue.isImportanceAvailable) summaryTag += ` ${itemValues.importance?.name}.`;
        if (initialValue.isUnitTypeAvailable) summaryTag += ` ${itemValues.unitType?.name}.`;

        return summaryTag;
    };

    const trigger = (
        <span>
            <b>{initialValue.name}</b> {!isOpen ? summaryTagGenerator() : null}
        </span>
    );


    return (<Collapsible trigger={trigger} onTriggerOpening={() => setIsOpen(true)} onTriggerClosing={() => setIsOpen(false)} overflowWhenOpen="visible">
        <StudyCustomisationModal show={showModal} itemId={initialValue.itemId} onClose={() => setShowModal(false)} fieldPrefix={field} formatOptions={formats} importanceOptions={importances} />
    </Collapsible>);
}

